/**
 * @func isFalsey
 * @param value - the input of the function
 * @return {boolean}
 * @desc Checks that the input is falsey
 *```js
 * isFalsey(9);
 * // returns false
 *
 * isFalsey(null);
 * //returns true
 *```
 * @memberof module:TypeCheck
 * @instance
 */
function isFalsey(value) {
    if (!value)
        return true;
    return false;
}

export { isFalsey as default };
